// NEW: UI_REVAMP
import {
	Box,
	CircularProgress,
	Flex,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import ImgComp from '../../utils/ImgComp';
import GlassMask from '../box/GlassMask';
import GlassButton from '../button/GlassButton';
import GoldPatternButton from '../button/GoldPatternButton';
import Loading from '../../utils/Loading';

const VARIANTS = {
	confirm: {
		bg: 'radial-gradient(41.9% 47.86% at 62.53% 27.99%, rgba(231, 177, 27, 0.60) 0%, rgba(218, 112, 26, 0.00) 100%), radial-gradient(37.72% 31.59% at 29.81% 27.99%, rgba(246, 11, 226, 0.40) 0%, rgba(246, 11, 234, 0.00) 100%), rgba(247, 248, 252, 0.40)',
		icon: 'confirm',
		leftButtonVariant: 'primary',
	},
	failed: {
		bg: 'radial-gradient(41.9% 47.86% at 62.53% 27.99%, rgba(231, 27, 37, 0.60) 0%, rgba(218, 26, 123, 0.00) 100%), radial-gradient(37.72% 31.59% at 29.81% 27.99%, rgba(246, 148, 11, 0.40) 0%, rgba(219, 246, 11, 0.00) 100%), rgba(247, 248, 252, 0.40)',
		icon: 'error',
		leftButtonVariant: 'primary',
	},
	alert: {
		bg: 'radial-gradient(41.9% 47.86% at 62.53% 27.99%, rgba(231, 27, 37, 0.60) 0%, rgba(218, 26, 123, 0.00) 100%), radial-gradient(37.72% 31.59% at 29.81% 27.99%, rgba(246, 148, 11, 0.40) 0%, rgba(219, 246, 11, 0.00) 100%), rgba(247, 248, 252, 0.40)',
		icon: 'alert',
		leftButtonVariant: 'primary',
	},
	success: {
		bg: 'radial-gradient(41.9% 47.86% at 62.53% 27.99%, rgba(27, 231, 41, 0.60) 0%, rgba(26, 218, 180, 0.00) 100%), radial-gradient(37.72% 31.59% at 29.81% 27.99%, rgba(246, 199, 11, 0.40) 0%, rgba(246, 211, 11, 0.00) 100%), rgba(247, 248, 252, 0.40)',
		icon: 'check',
		leftButtonVariant: 'lavender',
	},
	question: {
		bg: 'radial-gradient(41.9% 47.86% at 62.53% 27.99%, rgba(231, 177, 27, 0.60) 0%, rgba(218, 112, 26, 0.00) 100%), radial-gradient(37.72% 31.59% at 29.81% 27.99%, rgba(246, 11, 226, 0.40) 0%, rgba(246, 11, 234, 0.00) 100%), rgba(247, 248, 252, 0.40)',
		icon: 'question',
		leftButtonVariant: 'primary',
	},
	error: {
		bg: 'radial-gradient(41.9% 47.86% at 62.53% 27.99%, rgba(231, 27, 37, 0.60) 0%, rgba(218, 26, 123, 0.00) 100%), radial-gradient(37.72% 31.59% at 29.81% 27.99%, rgba(246, 148, 11, 0.40) 0%, rgba(219, 246, 11, 0.00) 100%), rgba(247, 248, 252, 0.40)',
		icon: 'error',
		leftButtonVariant: 'primary',
	},
	wrong: {
		bg: 'radial-gradient(41.9% 47.86% at 62.53% 27.99%, rgba(231, 27, 37, 0.60) 0%, rgba(218, 26, 123, 0.00) 100%), radial-gradient(37.72% 31.59% at 29.81% 27.99%, rgba(246, 148, 11, 0.40) 0%, rgba(219, 246, 11, 0.00) 100%), rgba(247, 248, 252, 0.40)',
		icon: 'wrong',
		leftButtonVariant: 'primary',
	},
};

const ModalIcon = ({ icon }) => {
	if (icon === 'question') {
		return (
			<Box
				position='relative'
				width='84px'
				height='84px'
				display='flex'
				alignItems='center'
				justifyContent='center'
			>
				<Box
					position='absolute'
					bottom='6px'
					width='65.9px'
					height='29.85px'
					borderRadius='999px'
					background='radial-gradient(50% 50% at 50% 50%, rgba(254, 119, 55, 0.6) 0%, rgba(254, 120, 56, 0) 100%)'
					filter='blur(8px)'
				/>
				<Box
					position='relative'
					zIndex={1}
					width='84px'
					height='84px'
					borderRadius='30px'
					background='#FFF1EB'
					boxShadow='0 8px 20px rgba(255, 241, 235, 0.28)'
					display='flex'
					alignItems='center'
					justifyContent='center'
				>
					<Flex
						width='55.8px'
						height='55.8px'
						borderRadius='full'
						alignItems='center'
						justifyContent='center'
						background='linear-gradient(180deg, #FFAD8A 0%, #FE7838 52%, #FE7636 100%)'
						boxShadow='0 10px 18px rgba(254, 119, 55, 0.28)'
					>
						<Text
							fontSize='52px'
							fontWeight='700'
							lineHeight='1'
							color='#FFFFFF'
							textShadow='0 2px 6px rgba(255, 221, 206, 0.55)'
							transform='translateY(-1px)'
						>
							?
						</Text>
					</Flex>
				</Box>
			</Box>
		);
	}

	if (icon === 'check' || icon === 'success') {
		return (
			<Box
				position='relative'
				width='84px'
				height='84px'
				display='flex'
				alignItems='center'
				justifyContent='center'
			>
				<Box
					position='absolute'
					bottom='6px'
					width='65.9px'
					height='29.85px'
					borderRadius='999px'
					background='radial-gradient(50% 50% at 50% 50%, rgba(19, 182, 1, 0.6) 0%, rgba(19, 182, 1, 0) 100%)'
					filter='blur(8px)'
				/>
				<Box
					position='relative'
					zIndex={1}
					width='84px'
					height='84px'
					borderRadius='30px'
					background='#E5F4D9'
					boxShadow='0 8px 20px rgba(229, 244, 217, 0.28)'
					display='flex'
					alignItems='center'
					justifyContent='center'
				>
					<Flex
						width='55.8px'
						height='55.8px'
						borderRadius='full'
						alignItems='center'
						justifyContent='center'
						background='linear-gradient(180deg, #CBF4B4 0%, #13B601 38%, #13B601 100%)'
						boxShadow='0 10px 18px rgba(19, 182, 1, 0.28)'
					>
						<Text
							fontSize='46px'
							fontWeight='700'
							lineHeight='1'
							color='#FFFFFF'
							textShadow='0 2px 6px rgba(255, 255, 255, 0.4)'
							transform='translateY(-1px)'
						>
							✓
						</Text>
					</Flex>
				</Box>
			</Box>
		);
	}

	if (icon === 'error' || icon === 'wrong') {
		return (
			<Box
				position='relative'
				width='84px'
				height='84px'
				display='flex'
				alignItems='center'
				justifyContent='center'
			>
				<Box
					position='absolute'
					bottom='6px'
					width='65.9px'
					height='29.85px'
					borderRadius='999px'
					background='radial-gradient(50% 50% at 50% 50%, rgba(239, 55, 57, 0.6) 0%, rgba(239, 55, 57, 0) 100%)'
					filter='blur(8px)'
				/>
				<Box
					position='relative'
					zIndex={1}
					width='84px'
					height='84px'
					borderRadius='30px'
					background='#FFE5E5'
					boxShadow='0 8px 20px rgba(255, 229, 229, 0.28)'
					display='flex'
					alignItems='center'
					justifyContent='center'
				>
					<Flex
						width='55.8px'
						height='55.8px'
						borderRadius='full'
						alignItems='center'
						justifyContent='center'
						background='linear-gradient(180deg, #FF8C8B 0%, #EF3739 38%, #EF3739 100%)'
						boxShadow='0 10px 18px rgba(239, 55, 57, 0.28)'
					>
						<Text
							fontSize='42px'
							fontWeight='700'
							lineHeight='1'
							color='#FFFFFF'
							textShadow='0 2px 6px rgba(255, 221, 210, 0.45)'
							transform='translateY(-1px)'
						>
							×
						</Text>
					</Flex>
				</Box>
			</Box>
		);
	}

	return <ImgComp svgName={icon} w='84px' h='auto' />;
};

const GlassModal = ({
	icon,
	title,
	desc = 'Please remind that this action cannot be retracted.',
	variant = 'confirm',
	isOpen,
	onClose,
	isLoading = false,
	showFooter = true,
	children,
	closeOnOverlayClick = true,
	leftButton = {},
	rightButton = {},
}) => {
	const currentVariant = VARIANTS[variant] || VARIANTS.confirm;
	const { bg, icon: defaultIcon, leftButtonVariant } = currentVariant;

	const finalIcon = icon || defaultIcon;
	const hasLeftButton = leftButton !== false && leftButton?.hidden !== true;
	const hasRightButton = rightButton !== false && rightButton?.hidden !== true;

	const handleLeftClick = leftButton?.onClick || onClose;
	const handleRightClick = rightButton?.onClick || (() => {});

	let bodyContent;

	if (isLoading) {
		bodyContent = <CircularProgress isIndeterminate size='120px' color='blue.600' />;
	} else if (children) {
		bodyContent = children;
	} else {
		bodyContent = (
			<>
				<ModalIcon icon={finalIcon} />

				<Text
					as='p'
					display='flex'
					flexDirection='column'
					gap='8px'
					alignItems='center'
					alignSelf='stretch'
				>
					<Text as='span' fontSize='24px' fontWeight='600' textAlign='center'>
						{title || 'Notice'}
					</Text>

					{desc && (
						<Text as='span' fontSize='16px' fontWeight='500' textAlign='center'>
							{desc}
						</Text>
					)}
				</Text>
			</>
		);
	}

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			isCentered
			closeOnOverlayClick={!isLoading && closeOnOverlayClick}
			closeOnEsc={!isLoading}
		>
			<ModalOverlay bg='rgba(0,0,0,0.6)' />

			<ModalContent
				display='flex'
				flexDirection='column'
				justifyContent='space-between'
				alignItems='center'
				p='16px 8px'
				maxW={{ base: '360px', lg: '450px' }}
				maxH={{ base: '360px', lg: '450px' }}
				w='full'
				h='auto'
				borderRadius={16}
				bg={bg}
				backdropFilter='blur(10px)'
				sx={{ WebkitBackdropFilter: 'blur(10px)' }}
				boxShadow='0 0 10px rgba(0,49,152,0.2)'
				style={{ aspectRatio: 1 }}
			>
				<GlassMask maskOpacity={0.6} />

				<ModalBody
					display='flex'
					flex='1'
					flexDirection='column'
					gap='16px'
					alignSelf='stretch'
					justifyContent='center'
					alignItems='center'
					color='white'
				>
					{bodyContent}
				</ModalBody>

				{/* Hide footer when loading */}
				{showFooter && !isLoading && (hasLeftButton || hasRightButton) && (
					<ModalFooter display='flex' alignItems='center' gap='8px' alignSelf='stretch'>
						{hasLeftButton && (
							<GlassButton
								onClick={handleLeftClick}
								variant={leftButton?.variant || leftButtonVariant}
								isDisabled={isLoading}
							>
								{leftButton?.text || 'Back'}
							</GlassButton>
						)}

						{hasRightButton && (
							<GoldPatternButton onClick={handleRightClick} isDisabled={isLoading}>
								{rightButton?.text || 'Confirm'}
							</GoldPatternButton>
						)}
					</ModalFooter>
				)}
			</ModalContent>
		</Modal>
	);
};

export default GlassModal;

export const ContainerLoadingModal = ({ isOpen, inset = '0', borderRadius = 'inherit' }) => {
	if (!isOpen) return null;

	return (
		<Flex
			position='absolute'
			inset={inset}
			zIndex='20'
			alignItems='center'
			justifyContent='center'
			background='rgba(224, 228, 255, 0.72)'
			backdropFilter='blur(2px)'
			borderRadius={borderRadius}
			pointerEvents='all'
			role='status'
			aria-label='Loading records'
		>
			<Loading />
		</Flex>
	);
};
